import TaxonomySelectPanelRow, {
  PANEL_TAXONOMY_SELECT_ID_PREFIX,
} from "../PanelRow/TaxonomySelectPanelRow";
import SubCategorySelect from "../SubCategorySelect/SubCategorySelect";

import type { TransactionCategory } from "../../hooks/useTransactionCategories";

interface SubCategoryPanelRowProps {
  transaction: API.Transaction;
  categories: TransactionCategory[];
  canWrite: boolean;
}

const SubCategoryPanelRow = ({
  transaction,
  categories,
  canWrite,
}: SubCategoryPanelRowProps) => {
  const parent = categories.find(
    (category) => category.label === transaction.category
  );
  const isChild = (parent?.sub_categories ?? []).some(
    (subCategory) => subCategory.label === transaction.sub_category
  );
  // The editor's select never shows a sub-category outside the current category, so the
  // read-only text must not either. An empty taxonomy cannot be checked; show the stored
  // value, as the editor does in that state.
  const text =
    categories.length === 0 || isChild ? transaction.sub_category : "";

  return (
    <TaxonomySelectPanelRow
      categories={categories}
      canWrite={canWrite}
      labelId="live-ledger-panel-subcategory-label"
      rowTestId="panel-subcategory-row"
      textTestId="panel-subcategory-text"
      text={text}
      select={
        <SubCategorySelect
          transaction={transaction}
          categories={categories}
          selectId={`${PANEL_TAXONOMY_SELECT_ID_PREFIX}subcategory-${transaction.id}`}
        />
      }
    />
  );
};

export default SubCategoryPanelRow;
